import { Controller } from "@hotwired/stimulus"
import { Sortable, Plugins, Sensors } from "@shopify/draggable"
import caseConverter from "../../helpers/case_converter_helper"
import loaderHelper from "../../helpers/loader_helper"

export default class extends Controller {
  static targets = ["galleryAlbum", "galleryImageAlbum"]
  static values = {
    onSortUrl: String,
    sortableOptionsSensor: { type: String, default: "DragSensor" },
    sortableOptionsDistance: { type: Number, default: 0 }
  }

  static classes = [ "emptyGalleryImageAlbum", "draggable" ]

  connect() {
    this.sortable = new Sortable(this.galleryAlbumTargets, {
      draggable: `.${this.draggableClass}`,
      handle: `.${this.draggableClass}`,
      swapAnimation: {
        duration: 100,
        easingFunction: "ease-in-out",
        horizontal: false,
      },
      distance: this.sortableOptionsDistanceValue,
      plugins: [Plugins.SwapAnimation],
      mirror: {
        constrainDimensions: true,
      },
      /*
        We use `DragSensor` instead of 'MouseSensor' by default
        because of a bug we discovered that happens exclusively on desktop
        browsers (which use `MouseSensor`) and when the sortable list is
        inside a fixed dialog.
        Mobile browsers use the `TouchSensor` by default so this change
        won't affect them.

        For more info, see:
        https://www.notion.so/Editor-v1-Drag-sort-offset-bug-on-desktop-browsers-1c4ab5cbbeca8078bee0f779921b4e13
      */
      ...(this.sortableOptionsSensorValue === "DragSensor" ? { sensors: [Sensors.DragSensor], exclude: { sensors: [Sensors.MouseSensor] } } : {}),
      ...(this.sortableOptionsSensorValue === "MouseSensor" ? { sensors: [], exclude: {} } : {})
    })

    this.sortable.on("sortable:stop", this._sortGalleryAlbumImages.bind(this))
  }

  disconnect() {
    this.sortable.off("sortable:stop", this._sortGalleryAlbumImages)
  }

  _sortGalleryAlbumImages({ oldContainer, newContainer }) {
    const galleryImageAlbumToken = newContainer.dataset.token || null
    const galleryImageAlbums = this.sortable.getDraggableElementsForContainer(newContainer)
    const galleryImageAlbumTokens = Array.from(galleryImageAlbums).map((albumImage) => albumImage.dataset.token)

    loaderHelper.show()

    Rails.ajax({
      url: this.onSortUrlValue,
      type: "PATCH",
      data: {
        [caseConverter.camelToSnake("draftGalleryImageAlbumToken")]: galleryImageAlbumToken,
        tokens: galleryImageAlbumTokens,
      },
      dataType: "json",
      beforeSend: (xhr, options) => {
        if (options.dataType === "json") {
          xhr.setRequestHeader("Content-Type", "application/json")
          options.data = JSON.stringify(options.data)
        }
        return true
      },
      complete: () => {
        loaderHelper.hide()

        if (this.sortable.getDraggableElementsForContainer(oldContainer).length === 0) {
          this._hideEmptyGalleryAlbum({ galleryAlbum: oldContainer })
        }
      }
    })
  }

  _hideEmptyGalleryAlbum({galleryAlbum}) {
    galleryAlbum.classList.add(this.emptyGalleryImageAlbumClass)
  }
}